export default {
  title: 'Actualizați profilul {{name}}',
  form: {
    name: {
      label: 'Nume',
      placeholder: 'Introduceți numele complet al proprietarului',
    },
    email: {
      label: 'E-mail',
      placeholder: 'Introduceți e-mailul personal al proprietarului',
      tooltip:
        'E-mailul personal al proprietarului/managerului restaurantului. Folosit pentru autentificarea în dashboard',
    },
  },
  buttons: {
    save: 'Salvați',
  },
  toasts: {
    failed_to_save_changes: 'Salvarea modificărilor a eșuat',
    changes_got_saved: 'Modificările au fost salvate',
  },
};
